import React, {FunctionComponent} from 'react';
import './BuildingLogo.css';

interface IBuildingLogo {
    src: string,
    alt: string
}

const BuildingLogo: FunctionComponent<IBuildingLogo> = ({src, alt}) => {
    return (
        <div className="row">
            <div className="building-logo text-center col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-8 col-xs-offset-2">
                <img className="img-responsive" src={src} alt={alt} />
            </div>
        </div>
    )
};

export default BuildingLogo;
